import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Products } from "./pages/Products";
import { Services } from "./pages/Services";
import { Contact } from "./pages/Contact";
import { Blog } from "./pages/Blog";
import { BlogPost1 } from "./pages/BlogPost1";
import { BlogPost2 } from "./pages/BlogPost2";
import { BlogPost3 } from "./pages/BlogPost3";
import { BOPPCoatingMachine } from "./pages/BOPPCoatingMachine";
import { SlittingRewindingMachine } from "./pages/SlittingRewindingMachine";
import { AdhesiveCoatingMachine } from "./pages/AdhesiveCoatingMachine";
import { TapeMakingMachine } from "./pages/TapeMakingMachine";
import { TapeManufacturingPlant } from "./pages/TapeManufacturingPlant";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/how-bopp-tape-is-manufactured" element={<BlogPost1 />} />
            <Route path="/blog/types-of-coating-machines" element={<BlogPost2 />} />
            <Route path="/blog/cost-of-tape-manufacturing-plant" element={<BlogPost3 />} />
            <Route path="/bopp-tape-coating-machine-manufacturer-india" element={<BOPPCoatingMachine />} />
            <Route path="/slitting-rewinding-machine-manufacturer-india" element={<SlittingRewindingMachine />} />
            <Route path="/adhesive-coating-machine-manufacturer-india" element={<AdhesiveCoatingMachine />} />
            <Route path="/tape-making-machine-supplier-india" element={<TapeMakingMachine />} />
            <Route path="/complete-tape-manufacturing-plant-setup-india" element={<TapeManufacturingPlant />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
